import React from 'react'
import ItemwiseSalesReport from '../Components/Reports/ItemwiseSalesReport'

function ItemWiseSalesReportPage() {
  return (
    <>
    <ItemwiseSalesReport/>
    </>
  )
}

export default ItemWiseSalesReportPage